import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingVariations(props) {

  const [variants, setVariants] = useState([
    { sku: "", size: "", color: "" }
  ]);

  const handleChange = (index, field, value) => {

    const updatedVariants = [...variants];
    updatedVariants[index][field] = value;
    setVariants(updatedVariants);

  };

  const addVariant = () => {

    setVariants([
      ...variants,
      { sku: "", size: "", color: "" }
    ]);

  };

  const removeVariant = (index) => {

    const updatedVariants = variants.filter((_, i) => i !== index);
    setVariants(updatedVariants);

  };

  return (

    <Container>

      <Row>

        {/* Title */}

        <Col md={12} className="mt-4 mb-3">
          <h4>Step 6 : Product Variations</h4>
        </Col>


        {/* Variants Card */}

        <Col md={12}>

          <Card className="p-4">

            <Row className="mb-3">
              <Col md={12}>
                <h5>Manage Variants</h5>
              </Col>
            </Row>


            {/* Table Header */}

            <Row className="mb-2 font-weight-bold">

              <Col md={3}><b>SKU</b></Col>
              <Col md={3}><b>Size</b></Col>
              <Col md={3}><b>Color</b></Col>
              <Col md={3}><b>Action</b></Col>

            </Row>


            {/* Variant Rows */}

            {variants.map((variant, index) => (

              <Row className="mb-2" key={index}>

                <Col md={3}>

                  <Input
                    type="text"
                    value={variant.sku}
                    onChange={(e) =>
                      handleChange(index, "sku", e.target.value)
                    }
                  />

                </Col>

                <Col md={3}>

                  <Input
                    type="text"
                    value={variant.size}
                    onChange={(e) =>
                      handleChange(index, "size", e.target.value)
                    }
                  />

                </Col>

                <Col md={3}>

                  <Input
                    type="text"
                    value={variant.color}
                    onChange={(e) =>
                      handleChange(index, "color", e.target.value)
                    }
                  />

                </Col>

                <Col md={3}>

                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => removeVariant(index)}
                  >
                    Delete
                  </button>

                </Col>

              </Row>

            ))}


            {/* Add Variant Button */}

            <Row className="mt-3">

              <Col md={12}>

                <button
                  className="btn btn-secondary"
                  onClick={addVariant}
                >
                  + Add Variant
                </button>

              </Col>

            </Row>

          </Card>

        </Col>


        {/* Navigation Buttons */}

        <Col md={12} className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <button
            className="btn btn-primary"
            onClick={props.nextStep}
          >
            Next →
          </button>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingVariations;